import { render, staticRenderFns } from "./AuthRegistration.vue?vue&type=template&id=3c3fd7fc&scoped=true&"
import script from "./AuthRegistration.vue?vue&type=script&lang=js&"
export * from "./AuthRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AuthRegistration.vue?vue&type=style&index=0&id=3c3fd7fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fd7fc",
  null
  
)

export default component.exports